
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/login",
      function () {
        return require("private-next-pages/[lng]/login.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/login"])
      });
    }
  